<template>
    <div class="page-content header-clear-medium">

		<div class="d-flex justify-content-center flex-wrap align-items-stretch">
			<div class="w-50">
				<router-link :to="{ name: 'quran.index' }">
					<div class="card card-style bg-blue-light">
						<div class="card-body text-center">
							<i class="bi bi-book font-50 d-block pb-2"></i>
							<h5 class="pt-2 font-200 color-white">Baca Alquran</h5>
						</div>
					</div>
				</router-link>
			</div>
			
			<div class="w-50">
				<router-link :to="{ name: 'quran.index' }">
					<div class="card card-style bg-pink-light">
						<div class="card-body text-center">
							<i class="bi bi-play-circle-fill font-50 d-block pb-2"></i>
							<h5 class="pt-2 font-200 color-white">Melanjutkan Baca</h5>
						</div>
					</div>
				</router-link>
			</div>
			
			<div class="w-50">
				<router-link :to="{ name: 'learnQuran' }">
					<div class="card card-style bg-green-light">
						<div class="card-body text-center">
							<i class="bi bi-stack-overflow font-50 d-block pb-2"></i>
							<h5 class="pt-2 font-200 color-white">Belajar Quran</h5>
						</div>
					</div>
				</router-link>
			</div>

			<div class="w-50">
				<router-link :to="{ name: 'quran.index' }">
					<div class="card card-style bg-magenta-dark">
						<div class="card-body text-center">
							<i class="bi bi-search font-50 d-block pb-2"></i>
							<h5 class="pt-2 font-200 color-white">Pencarian Kata</h5>
						</div>
					</div>
				</router-link>
			</div>
		</div>
        
    </div>
</template>

<script>
export default {
	name: 'Home',
	data() {
		return {
			
		}
	},
	async created() {
		
	},
    methods: {
		
    },
    computed: {

    }
}
</script>
